import React, { useEffect } from "react";
import { Button, Drawer, Form, Input, Space, Switch } from "antd";

export default function CatalogItemDrawer({
  open,
  onClose,
  onSubmit,
  loading,
  initialValues,
  title = "Catalog Item",
  codeReadOnly = false,
}) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (!open) return;
    form.resetFields();
    if (initialValues) {
      form.setFieldsValue({
        ...initialValues,
        active: initialValues.active ?? true,
      });
    } else {
      form.setFieldsValue({ active: true });
    }
  }, [open, form, initialValues]);

  return (
    <Drawer
      title={initialValues?.id ? `Edit ${title}` : `Create ${title}`}
      width={560}
      open={open}
      onClose={onClose}
      destroyOnClose
      placement="right"
      zIndex={2000}
      footer={
        <Space style={{ width: "100%", justifyContent: "flex-end" }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="primary" loading={loading} onClick={() => form.submit()}>
            Save
          </Button>
        </Space>
      }
    >
      <Form form={form} layout="vertical" onFinish={onSubmit} initialValues={{ active: true }}>
        <Form.Item
          name="code"
          label="Code"
          rules={[{ required: true, message: "Code is required" }]}
        >
          <Input placeholder="UNIQUE_CODE" disabled={codeReadOnly && Boolean(initialValues?.id)} />
        </Form.Item>
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: "Name is required" }]}
        >
          <Input placeholder={`${title} name`} />
        </Form.Item>
        <Form.Item name="description" label="Description">
          <Input.TextArea rows={4} placeholder={`Describe this ${title.toLowerCase()}`} />
        </Form.Item>
        <Form.Item name="active" label="Active" valuePropName="checked">
          <Switch />
        </Form.Item>
      </Form>
    </Drawer>
  );
}

